module.exports = __webpack_public_path__ + "img/right-arrow-black.25ad08b4.svg";